import React, { Component } from 'react';
import { Link } from 'react-router';

// import './style.css';
import Button from './../button/Button';


export default class SuccessRegistration extends Component {

  render() {
    return (
      <div className='error'>
        <div className='error__text'>Поздравляем! Регистрация прошла успешно</div>
        <Link to='/'>
          <Button styleClasses={['error__button']} >
            На главную
          </Button>
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/success/SuccessRegistration.js